import React from "react";
import "./styles.css";
import { ScoreMeter, Title } from "../../Components/Atoms";
import { getStatLabel } from "../../Library/helpers";

const RidingScore = ({ ridingScoreDetails = {}, showOnlyRidingEvents = false }) => {
  const RIDING_EVENTS = [
    { key: "HARSH_ACCELERATION", label: "Harsh Acceleration" },
    { key: "SHARP_TURN", label: "Sharp Turn" },
    { key: "SUDDEN_BRAKE", label: "Sudden Breaking" },
    { key: "OVERSPEED", label: "Overspeed Limit" },
  ];

  const RIDING_STATS = [
    { key: "totalDst", label: "Total Distance", format: "distance" },
    { key: "maxDur", label: "Duration", format: "duration" },
    { key: "avs", label: "Avg. Speed", format: "speed" },
    { key: "tps", label: "Top Speed", format: "speed" },
  ];

  return (
    <div className="riding-score-container">
      <div className="riding-score-title">
        <Title>{showOnlyRidingEvents ? "Riding Score" : "Lifetime Riding Score"}</Title>
      </div>
      <div className="riding-score">
        <ScoreMeter
          score={ridingScoreDetails.rideScore || 0}
          showAboutScore={true}
        />
        <div className="riding-score-separator"></div>
        <div className="riding-score-overview">
          <div className="rso-head">
            <h3>Riding Score Overview</h3>
            <hr />
          </div>
          <div className="rso-value-container">
            {showOnlyRidingEvents ? (
              <>
                <div className="rso-value-grid-only">
                  {RIDING_EVENTS.map((event, idx) => (
                    <div className="riding-score-val" key={idx}>
                      <span className="val">
                        {ridingScoreDetails &&
                        ridingScoreDetails.rideScoreCounts &&
                        ridingScoreDetails.rideScoreCounts[event.key]
                          ? ridingScoreDetails.rideScoreCounts[event.key]
                          : "0"}
                      </span>
                      <span className="abt">{event.label}</span>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <>
                <div className="rso-value-grid">
                  {RIDING_EVENTS.map((event, idx) => (
                    <div className="riding-score-val" key={idx}>
                      <span className="val">
                        {ridingScoreDetails &&
                        ridingScoreDetails.rideScoreCounts &&
                        ridingScoreDetails.rideScoreCounts[event.key]
                          ? ridingScoreDetails.rideScoreCounts[event.key]
                          : "N/A"}
                      </span>
                      <span className="abt">{event.label}</span>
                    </div>
                  ))}
                </div>

                <div className="rso-separator"></div>

                <div className="rso-value-grid">
                  {RIDING_STATS.map((stat, idx) => (
                    <div className="riding-score-val" key={idx}>
                      <span className="val">
                        {getStatLabel(
                          Number(ridingScoreDetails[stat.key]),
                          stat.format,
                          1
                        )}
                      </span>
                      <span className="abt">{stat.label}</span>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RidingScore;
